import * as React from 'react'

import { Box, Button, Icon, List, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const AdminBookkeeperBlock = () => {
  const { navigation } = useNavigation()

  return (
    <>
      <Box paddingX="s48" width="full" paddingY="s16">
        <Box flexDirection="row" paddingBottom="s24" gap="s12" alignItems="center">
          <Icon.Large icon="pig" />
          <Text color="grey1000" size="400" weight="medium">
            {i18n.t('notifications.bookkeepers.incidence.label.admin')}
          </Text>
        </Box>
        <Box
          background="champagne100"
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          borderRadius={{
            all: 'abs008',
          }}
          paddingY="s16"
          paddingX="s24"
          gap="s16"
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: 'grey400',
            },
          }}
        >
          <Box flexGrow flexDirection="column" gap="s4">
            <List.Title>
              {i18n.t('notifications.bookkeepers.incidence.options.admin_and_bookkeeper.bold')}
            </List.Title>
            <List.Description>
              {i18n.t('notifications.bookkeepers.incidence.options.admin_and_bookkeeper.normal')}
            </List.Description>
          </Box>
          <Button.Router to={navigation.bookkeepers.settings.fullPath()} type="primary">
            {i18n.t('notifications.bookkeepers.incidence.options.admin_and_bookkeeper.button')}
          </Button.Router>
        </Box>
      </Box>
    </>
  )
}

export default AdminBookkeeperBlock
